import { useTriggerAction, useUpdateWidget } from '@libs/core';
import { ActionActionTypeEnum, TWAction, TWidgetProps } from '@libs/types';
import React, { Activity, useEffect, useEffectEvent, useRef } from 'react';
import { TMpiData } from '../../types/data';
import { getInlineStyles } from '../../utils/styles';
import { LoadingAnimationView } from '../Animation/LoadingAnimationView';
import styles from './mpi.module.css';

export const Mpi = ({ widget }: TWidgetProps<TMpiData>) => {
    const { actions, data } = widget;
    const redirect = data.redirect;
    const collectBrowserDataUri = data.collectBrowserDataUri;

    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const { triggerAction } = useTriggerAction(widget);
    const { updateWidget } = useUpdateWidget(widget.uid);

    const getActionByType = (actions: TWAction[] | undefined, actionType: ActionActionTypeEnum) => actions?.filter((f) => f.actionType === actionType)?.[0];
    const onTriggerAction = useEffectEvent((action: TWAction) => {
        return triggerAction(action);
    });

    useEffect(() => {
        const updateData = () => {
            const finalAction = getActionByType(actions, ActionActionTypeEnum.onCalculate);
            if (finalAction) {
                onTriggerAction(finalAction).then();
            } else {
                const updateAction = getActionByType(actions, ActionActionTypeEnum.onTimer);
                if (updateAction) {
                    timeoutRef.current = setTimeout(() => onTriggerAction(updateAction), updateAction.delay);
                }
            }
        };
        updateData();
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [actions, updateWidget, widget]);

    return (
        <div className={styles.mpiFrame} data-test={widget.uid} style={getInlineStyles({ margin: widget.options?.margin })}>
            <Activity mode={redirect ? 'visible' : 'hidden'}>
                <div className={styles.redirectFrame}>
                    <iframe
                        className={styles.frame}
                        src={redirect}
                        title={'redirectFrame'}
                        sandbox="allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-modals allow-pointer-lock allow-presentation"
                    />
                </div>
            </Activity>
            <Activity mode={!redirect ? 'visible' : 'hidden'}>
                <LoadingAnimationView />
            </Activity>
            <Activity mode={collectBrowserDataUri ? 'visible' : 'hidden'}>
                <div className={styles.collectFrame}>
                    <iframe
                        className={styles.frame}
                        src={collectBrowserDataUri}
                        title={'collectFrame'}
                        sandbox="allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-modals allow-pointer-lock allow-presentation"
                    />
                </div>
            </Activity>
        </div>
    );
};
